const dateTimeKeys: string[] = ["updatedAt", "readyBy"];

const dateKeys: string[] = ["lastInstallmentDate"];

const currencyKeys = [
  "downpayment",
  "remainingInstallments",
  "askingPrice",
  "actualPrice",
  "maintenance",
];

export function getListingDisplayValue(key: string, value: any): string {
  if (dateTimeKeys.includes(key) && typeof value === "string") {
    return new Date(value).toLocaleString();
  } else if (dateKeys.includes(key) && typeof value === "string") {
    return new Date(value).toLocaleDateString();
  } else if (currencyKeys.includes(key) && typeof value === "number") {
    return `${value.toLocaleString()} EGP`;
  } else if (typeof value === "object") {
    return value?.name;
  } else if (value !== undefined && value !== null) {
    return value.toString();
  }
  return "-";
}
